import React from 'react';
import { connect } from 'react-redux';

import { IFieldById } from '../../../../../types/core';
import { IRefTableColumn } from '../../../../../types/space';
import { checkIfLookupIsLookingAtRecordReference } from '../../../../../modules/core/helpers';
import { ColumnType } from '../../../../../modules/core/graphql/types';
import { IRootState } from '../../../../../modules/stores';

interface IProps {
  fieldById: { [key: string]: IFieldById };
  tableColumns: IRefTableColumn[];
  showRefAsText: boolean;
  visibleNodes: { [key: string]: string };
  depth?: number;
}

const Header: React.FC<IProps> = ({
  fieldById,
  tableColumns,
  showRefAsText,
  visibleNodes,
  depth,
}) => {
  // force show reference as text if at depth limit
  let refAsText = depth && depth > 2 ? true : showRefAsText;
  return (
    <tr>
      {tableColumns.map((c, index: number) => {
        const field = fieldById[c.id];
        // Protention against absent fields
        if (!field) return null;

        const isNodeVisible =
          (field.type === ColumnType.RECORD_REFERENCE || field.type === ColumnType.SUBTABLE) &&
          visibleNodes[field.typeOptions.foreignTableId];

        if (
          ((field.type === 'RECORD_REFERENCE' || field.type === 'SUBTABLE') &&
            !refAsText &&
            isNodeVisible) ||
          (checkIfLookupIsLookingAtRecordReference(field) && !refAsText)
        )
          return null;

        return (
          <th key={`fieldId-${index}`} style={{ padding: '5px' }}>
            <div>{c.displayName || field.name}</div>
          </th>
        );
      })}
    </tr>
  );
};

const mapState = ({ core }: IRootState) => ({
  visibleNodes: core.visibleNodes,
});

export default connect(mapState)(Header);
